import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, setBlockTracking as _setBlockTracking, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "super"
}
const _hoisted_2 = { class: "name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckCircle = _resolveComponent("CheckCircle")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["head-row no-user-select", {
      selected: _ctx.item.selected,
      [`head-row--${_ctx.item.dayId}`]: true,
    }]),
    style: _normalizeStyle({ height: `${_ctx.item.size}px` })
  }, [
    (_ctx.item.super !== undefined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.item.super), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "main",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.click && _ctx.click(...args)))
    }, [
      _cache[0] || (
        _setBlockTracking(-1, true),
        (_cache[0] = _createVNode(_component_CheckCircle, {
          size: 20,
          class: "select"
        })).cacheIndex = 0,
        _setBlockTracking(1),
        _cache[0]
      ),
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.name), 1)
    ])
  ], 6))
}